import React, { useEffect, useState,useContext,useRef,useMemo } from "react";
import logoIcon from "../../assets/images/Jobs Genius Icon.png";
import moment from "moment";
import "./SerpJobs.scss";
import { JobApi } from "../../api/jobApi";
import { JobOfferingContext } from "../../context/JobOfferringContext";
import useQueryHook from "../../customHooks/useQueryHook";
import FireTracking from "../../assets/FireTracking/fireTracking";
import { TYPE_TRACKING } from "../../constants/TrackingConstant";
import { ApiTypeConstant, PayOptionConstant } from "../../constants/JobConstant";

import { publisherConstant } from "../../constants/JobConstant";

function SerpJobs({ item, idx, keyword, jobDisplayArray }) {
  const serpPubId = process.env.REACT_APP_SERP_PUB_ID;

  const [logo, setLogo] = useState(null);
  const [keywordImage,setKeywordImage]=useState();

  const { jobs, setJobs, payOutRev } = useContext(JobOfferingContext);
  const { queryString, queryParams, pixelFire, skipPixelFIre, applyPixelFire, fireSerpPixel } = useQueryHook();
  const campaignId = queryParams.get("camp_id");
  const keywordforLogo=queryParams.get('keyword');
  const subId = queryParams.get("sub_id") || queryParams.get("subid") || queryParams.get("subId");
  const source = queryParams.get("source");
  const zip = queryParams.get("zip") || queryParams.get("userzip") || queryParams.get("user_zip") || queryParams.get("userZip");
    const [currentJobIndex, setCurrentJobIndex] = useState(0);
    const params = JSON.parse(localStorage.getItem('job-genius-user-info'));

    const currentJob = jobs[currentJobIndex];
      let userCity = useRef("");
      let userState = useRef("");
      let userZip = useRef('');
      const isTesting = queryParams.get('testing');
      const isTesting2 = queryParams.get('testing2');
      const isTesting3 = queryParams.get('testing3');
      const jgcid = queryParams.get('jgcid');
      const userAgent= navigator.userAgent; 


      const testObj = useMemo(() => {
    
        return {
          keyword,
          campaignId,
          subId,
          source,
          testing: isTesting || false,
          testing2: isTesting2 || false,
          testing3: isTesting3 || false,
          zip,
          page: 0,
          size: 6, 
        };
      }, [keyword, campaignId, isTesting, subId]);
  useEffect(() => {
      const fetchJobLogo = () => {
       const companyNames = item?.jobType
    ? [keywordforLogo]
    : [item?.importCompanyName, item?.companyName, item?.company, keywordforLogo].filter(Boolean);

        const tryFetchLogo = (index) => {
          if (index >= companyNames.length) {
            setLogo(null);
            return;
          }

          JobApi.fetchLogo(companyNames[index])
            .then((logoResponse) => {
              const fetchedLogo = logoResponse?.data?.[0]?.image;
              if (fetchedLogo) {
                setLogo(fetchedLogo);
              } else {
                tryFetchLogo(index + 1);
              }
            })
            .catch(() => {
              tryFetchLogo(index + 1);
            });
        };

        tryFetchLogo(0);
      };

      fetchJobLogo();
  }, [jobDisplayArray]);


const buildDataTracking = (currJob) => ({
  jobId: currJob?.jobId || 0,
  majorCategory: currJob?.majorCategory,
  conversion: 1,
  keyword,
  inboundUrl: document.referrer + queryString,
  jgcid,
  subid: subId,
  source,
});

const appendAppcastParams = (url) => {
  if (subId) url.searchParams.set("subid", subId);
  if (source) url.searchParams.set("source", source);
  return url;
};

const buildShaUrlWithParams = (currJob) => {
  if (!params) return `${currJob.shaUrl}${queryString || ""}`;
  const paramString = queryString
    ? `${queryString}&first_name=${params.firstName}&last_name=${params.lastName}&email=${params.email}&phone=${params.phoneNumber}&zip=${zip || userZip.current}`
    : `?first_name=${params.firstName}&last_name=${params.lastName}&email=${params.email}&phone=${params.phoneNumber}&zip=${zip || userZip.current}`;
  return `${currJob.shaUrl}${paramString}`;
};

const onApply = (currJob) => {
  console.log("1231200000", currJob?.apiJob);

  const dataTracking = buildDataTracking(currJob);

  if (currJob?.url) {
    pixelFire("apiclick");
    fireSerpPixel("serpclick");
    FireTracking(TYPE_TRACKING.applyJob, dataTracking);

    let windowAddress = new URL(currJob.url, window.location.origin);
    if (currJob?.feedSource === "appcast") {
      windowAddress = appendAppcastParams(windowAddress);
    }

    window.open(windowAddress);
  } else {
    dataTracking.publisherId = serpPubId;
    fireSerpPixel("serprev", currJob?.bid);
    FireTracking(TYPE_TRACKING.applyJob, dataTracking);

    const finalUrl = buildShaUrlWithParams(currJob);
    window.open(finalUrl);
  }
};

  const formattedDate = (() => {
    const dateStr = item.date || item.posted_at || item.createdDate;
    if (!dateStr) return "No date available";
    try {
      const date = moment(dateStr); // Parse the date
      const now = moment();

      const hours = now.diff(date, "hours");
      const days = now.diff(date, "days");
      const weeks = now.diff(date, "weeks");

      if (hours < 24) {
        return `${hours} ${hours === 1 ? "hour" : "hours"} ago`;
      } else if (days < 7) {
        return `${days} ${days === 1 ? "day" : "days"} ago`;
      } else {
        return `${weeks} ${weeks === 1 ? "week" : "weeks"} ago`;
      }
    } catch (error) {
      console.error("Error parsing date:", error);
      return "Invalid date";
    }
  })();

    useEffect(() => {
    const fetchKeywordLogos = async () => {
      try {
        const { data } = await JobApi.getKeywordImage({keyword});
        setKeywordImage(data?.image)
      } catch (error) {
        console.error("Error fetching keyword image:", error);
      }
    };
    fetchKeywordLogos();
  }, []);

  return (
    <div className="job-container">
      <div className="job-info">
        <div className="values">
          <div className="job-company-logo">
            <img
              src={item.logo || item.logo_url || item.companyLogo || keywordImage || logo|| logoIcon }
              alt="JobGenius"
              className="logo-image"
            />
          </div>
          <div className="job-title">
            <div className="title">
              <span className="main-title" >
                
                {" "}
                {item.jobtitle || item.title}
              </span>
              <span className="company">
                {item.company || item.employer || item.importCompanyName || item.companyName} |{" "}
                {item.city || item.location?.city || item.cityName}
                {item.state || item.location?.state
                  ? `, ${item.state || item.location?.state}`
                  : ""}
              </span>
              <span className="company">{formattedDate}</span>
            </div>
          </div>
        </div>
        <div className="job-apply">
          <button onClick={()=>onApply(item)}>Quick apply</button>
        </div>
      </div>
    </div>
  );
}

export default SerpJobs;
